<template>
<div id="newsletter-calendar">
  <h2>
    Newsletter Calendar
  </h2>

</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: mapState({
    base: state => state.base,
    loaders: state => state.LoaderModule.loaders,
    newsletters: state => state.NewsletterModule.user
  }),

  props: {
    dateStart: {
      type: [Number, String],
      default: () => {
        return Date.now()
      }
    },
    dateEnd: {
      type: [Number, String],
      default: () => {
        return Date.now()
      }
    }
  },

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterCalendar.vue